import React, { useState, useEffect } from 'react';
import { Box, Grid, IconButton, Modal } from '@material-ui/core';
import { ReactComponent as CloseIcon } from '../../../assets/icons/icon-cross-circle.svg';
import ButtonComponent from '../../atoms/button';
import Typography from '../../atoms/typography';
import Input from '../../atoms/input';
import { Controller, useFormContext } from 'react-hook-form';
import RadioGroupCustom from '../../atoms/radioGroupCustom';
import InputDisabled from '../../atoms/inputDisabled';

interface ModalProps {
  open: boolean;
  onCancelClick: () => void;
  onNextStep: () => void;
  onChangeSelectedValue: (value: string) => void;
  selectedValue: string;
}

const ModalCustomizeFreight: React.FC<ModalProps> = ({
  open,
  onCancelClick,
  onNextStep,
  onChangeSelectedValue,
}) => {
  const { control, setValue, watch } = useFormContext();
  const [localSelectedValue, setLocalSelectedValue] =
    useState<string>('option1');
  const [freightCost, setFreightCost] = useState<string | null>(null);
  const [isPublishButtonDisabled, setIsPublishButtonDisabled] =
    useState<boolean>(true);

  const options: { value: string; label: string }[] = [
    { value: 'option1', label: 'Manter valor da Fretapp' },
    { value: 'option2', label: 'Customizar valor do frete' },
  ];

  useEffect(() => {
    setIsPublishButtonDisabled(
      localSelectedValue === 'option2' &&
        (freightCost === null || freightCost === '' || isNaN(Number(freightCost))),
    );
  }, [localSelectedValue, freightCost]);

  useEffect(() => {
    const watchedFreightCost = watch('freightCost');
    setFreightCost(watchedFreightCost ? watchedFreightCost.toString() : null);
  }, [watch]);

  const handleNextStep = () => {
    onNextStep();
  };

  const handleFreightCostChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cost = e.target.value;
    setFreightCost(cost);
    setValue('freightCost', cost);
  };

  return (
    <div className="container-body no-padding">
      <Modal
        open={open}
        onClose={onCancelClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box style={{ backgroundColor: 'white', padding: 20, borderRadius: 4 }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography fontWeight="700" color="secondary" mb={2}>
              Publicar frete
            </Typography>
            <IconButton aria-label="close" onClick={onCancelClick}>
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography color="secondary" mb={2}>
              Você está prestes a publicar este frete. Deseja manter o valor
              <br />
              sugerido pela Fretapp?
            </Typography>
          </Grid>
          <Grid>
            <RadioGroupCustom
              name="customizeFreightCost"
              options={options}
              control={control}
              selectedValue={localSelectedValue}
              onChange={(value: string) => {
                setLocalSelectedValue(value);
                onChangeSelectedValue(value);
              }}
            />
            {localSelectedValue === 'option1' ? (
              <Controller
                name="freightCost"
                control={control}
                render={({ field: { value } }) => (
                  <InputDisabled
                    label={'Custo do frete'}
                    value={Number(value).toFixed(2)}
                    startAdornment={'R$ '}
                  />
                )}
              />
            ) : (
              <>
                <Input
                  label={'Custo de frete'}
                  placeholder=" Informe o valor aqui"
                  name="freightCost"
                  maxLength={20}
                  type='number'
                  control={control}
                  value={freightCost || ''}
                  onChange={handleFreightCostChange}
                  startAdornment={'R$ '}
                />
                <Typography fontSize="xs" color="error" mt={2}>
                  Este valor irá sobrescrever o valor sugerido pela Fretapp e
                  <br />
                  não pode ser desfeito.
                </Typography>
              </>
            )}
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            spacing={2}
            style={{ marginTop: 10 }}
          >
            <Grid item>
              <ButtonComponent theme="outline-primary" onClick={onCancelClick}>
                Cancelar
              </ButtonComponent>
            </Grid>
            <Grid item>
              <ButtonComponent
                onClick={handleNextStep}
                disabled={isPublishButtonDisabled}
              >
                Publicar
              </ButtonComponent>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default ModalCustomizeFreight;
